class ClickableHero {

    constructor(el) {
        this.el = el;
        this.contentArea = this.el.querySelector('.hero--image, .hero--video-inner');
        if(this.contentArea != null) {
            this.firstLink = this.el.querySelector('.hero--content--inner a, .hero--content--inner button');
            if(this.firstLink != null) {
                this.el.classList.add('enabled');
                let _link = this.firstLink;
                this.contentArea.onclick = (e) => {
                    e.preventDefault();
                    _link.click();
                };
            }
        }
    }

}

export function createFrom(wrappers) {
    wrappers.forEach((node) => {
        // if node is an element
        if (node.nodeType === 1) {
            new ClickableHero(node);
        }
    });
}
